import { motion, useReducedMotion } from "framer-motion";
import { Reveal } from "./motion";
import { InViewTextEffect } from "@/components/ui/text-effect";
import RouteWaypoints from "./RouteWaypoints";

const PHONE = "(719) 440-9494";
const PHONE_HREF = "tel:+17194409494";

export default function FinalCTA() {
    const reduce = useReducedMotion();
    return (
          <section
                  id="contact"
                  className="relative z-10 overflow-hidden border-t border-hairline px-5 py-28 md:px-8 md:py-40"
                  data-testid="final-cta-section"
                >
            {/* faint route echo behind — the same line the site opened with */}
                <div className="pointer-events-none absolute inset-x-0 bottom-0 opacity-40" aria-hidden="true">
                        <div className="mx-auto max-w-4xl">
                                  <RouteWaypoints
                                    viewBox="0 0 560 220"
                                    animate={!reduce}
                                    points={[
                                      [0.05, 0.82], [0.32, 0.6], [0.5, 0.66], [0.68, 0.34], [0.95, 0.22],
                                    ]}
                                    waypoints={[
                                      { at: 0, lit: false },
                                      { at: 4, lit: false },
                                    ]}
                                  />
                        </div>
                </div>
          
                <div className="relative mx-auto max-w-4xl text-center">
                        <InViewTextEffect
                                  as="p"
                                  preset="blur"
                                  className="font-mono text-[11px] uppercase tracking-[0.24em] text-rust"
                                >
                                  CH.07 // Rendezvous
                        </InViewTextEffect>
                
                        <Reveal
                                    as="h2"
                                    delay={0.05}
                                    className="mt-6 font-serif text-5xl font-medium leading-[0.98] tracking-tight text-ink md:text-7xl lg:text-8xl"
                                  >
                                  Ready to get it <em className="italic text-pine">built right</em>?
                        </Reveal>
                
                        <Reveal
                                    delay={0.12}
                                    className="mx-auto mt-7 max-w-lg text-base leading-relaxed text-ink-dim md:text-lg"
                                  >
                                  <p>No forms, no funnel. Text or call — we'll map it out together.</p>
                        </Reveal>
                
                        <Reveal delay={0.18} className="mt-11 flex flex-col items-center gap-4">
                                  <motion.a
                                                href={PHONE_HREF}
                                                data-testid="final-cta-phone"
                                                whileHover={{ scale: 1.03 }}
                                                whileTap={{ scale: 0.97 }}
                                                className="inline-flex items-center gap-3 rounded-full bg-pine px-9 py-5 font-mono text-sm uppercase tracking-[0.16em] text-paper"
                                              >
                                              <span className="h-2 w-2 rounded-full bg-paper/70" />
                                    {PHONE}
                                  </motion.a>
                                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-dim">
                                              Peyton, CO · Same-day during a build
                                  </span>
                                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-ink-dim">
                                              By appointment only
                                  </span>
                        </Reveal>
                </div>
          </section>
        );
}
